import AnalyticsList from "./analytics/AnalyticsList";
import AnalyticsPage from "./analytics/AnalyticsPage";
import ConversationList from "./conversation/ConversationList";
const rootSupervision = "company/:company/supervision/";
const routes = [
    {path : rootSupervision + 'conversations/list', component : () => <ConversationList/>, isSidebar : true, isPublic : false , permissions:['view_conversations']},
    {path : rootSupervision + 'analytics/list', component: () => <AnalyticsList/>, isPublic : false, isSidebar : true , permissions:['view_analytics']},
    {path : rootSupervision + 'analytics/:bot', component: () => <AnalyticsPage/>, isPublic : false, isSidebar : true},
]

export default routes;